import React, { useContext, useMemo } from "react";
import "./DocumentDetail.css";
import Header from "./Header/Header";
import DuplicateNotification from "./DuplicateNotification/DuplicateNotification";
import { DocumentDetailContext } from "./contexts/DocumentDetailContext";
import Flags from "./Flags/Flags";
import FaxPageDrop from "./FaxPageDrop/FaxPageDrop";
import Classification from "./Classification/Classification";
import EhrDetails from "./EHRDetails/EhrDetails";
import DocumentDescription from "./DocumentDescription/DocumentDescription";
import Extraction from "./Extraction/Extraction"
import ButtonHandler from "./ButtonHandler/ButtonHandler";
import DocumentPreview from "./DocumentPreview/DocumentPreview";
import Dialogs from "./Dialogs/Dialogs";
import DocumentSplit from "./DocumentSplit/DocumentSplit";
import * as c from "utils/constants/constants"
import { CircularProgress } from "@mui/material";

const DocumentDetailWrapper = () => {
    const { data = {}, duplicateDocumentView, _baseClassName, loader, docSplit } = useContext(DocumentDetailContext);

    const disableEdit = useMemo(() => {
        const { Entity_Details = {} } = data || {};

        if (data?.Status === c.status.uploading || data?.Status === c.status.completing || data?.Status === c.status.completed ||
            data?.Status === c.status.uploaded || [5001, 5002, 5003, 5004, 5005, 5006, 5007, 5008, 5009].includes(data?.Error_Code)) return true
        else if (data?.Status === c.status.uploaded && !Entity_Details.is_epic_confirmation_received) return true;
        else if (Entity_Details?.fax_cover_page_drop?.status == "In Progress") return true; return false;
    }, [data]);

    return loader ? <CircularProgress size={30} className="common-spinner" /> : <div style={{ width: "100%", display: "flex", marginTop: "60px" }}>
        <div className={`${_baseClassName}-container`}>
            <Header />
            <ButtonHandler />
            <DuplicateNotification />
            <div style={{ margin: "15px 20px", pointerEvents: disableEdit ? "none" : "auto", cursor: disableEdit ? "alias" : "auto" }}>
                <div style={{ display: "flex" }}>
                    <Flags />
                    {!docSplit.isDocSplitEnabled && <FaxPageDrop />}
                </div>
                {docSplit.isDocSplitEnabled ? <DocumentSplit /> : <>
                    <Classification />
                    <EhrDetails />
                    <DocumentDescription />
                    <Extraction />
                </>}
            </div>
            <Dialogs />
        </div>
        <DocumentPreview />

    </div>
}

export default DocumentDetailWrapper;